import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="confetti"
// Plays a lightweight CSS confetti animation on connect, auto-cleans up after 3s.
export default class extends Controller {
  connect() {
    this.createConfetti()
    this.timeoutId = setTimeout(() => this.cleanup(), 3000)
  }

  createConfetti() {
    const colors = ["#10b981", "#3b82f6", "#f59e0b", "#ef4444", "#8b5cf6"]
    const container = document.createElement("div")
    container.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:50;overflow:hidden"

    for (let i = 0; i < 50; i++) {
      const piece = document.createElement("div")
      piece.style.cssText = `
        position:absolute;
        width:${6 + Math.random() * 6}px;
        height:${6 + Math.random() * 6}px;
        background:${colors[Math.floor(Math.random() * colors.length)]};
        left:${Math.random() * 100}%;
        top:-10px;
        border-radius:${Math.random() > 0.5 ? "50%" : "0"};
        animation:confetti-fall ${2 + Math.random() * 2}s ease-out forwards;
        animation-delay:${Math.random() * 0.5}s;
      `
      container.appendChild(piece)
    }

    this.element.appendChild(container)
    this.container = container
  }

  cleanup() {
    if (this.container) {
      this.container.remove()
    }
  }

  disconnect() {
    clearTimeout(this.timeoutId)
    this.cleanup()
  }
}
